import type { GridColumnProps } from "@tql/ui-components-react/kendo/grid";

import type { BoardColumn } from "~/shared/types/quote-board-types.ts";

/**
 * Process columns for grid display - filters visible columns and adds column menu
 */
export const processGridColumns = (columns: BoardColumn[]): BoardColumn[] => {
	return Array.isArray(columns)
		? columns
				.filter((col) => col.show)
				.map((col) => ({
					...col,
				}))
		: [];
};

/**
 * Convert BoardColumns to GridColumnProps for Kendo Grid compatibility
 */
export const convertToGridColumnProps = (
	columns: BoardColumn[],
): GridColumnProps[] => {
	return columns.map((col) => {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Variables extracted for type safety but not used in return
		const { show, menu, type, ...gridColumnProps } = col;

		// For columns with custom sorting, we enable basic sorting
		// The custom logic should be handled in data preprocessing
		return {
			...gridColumnProps,
			sortable: col.sortable !== false,
		};
	});
};
